<template>
  <b-container>
    <b-card no-body>
      <b-card-header>
        <b-card-title>Templates</b-card-title>
      </b-card-header>
      <b-card-body>
        <b-table
          :items="templatelijst"
          :fields="['Omschrijving','Unit',{key:'Datum',label:'Inspectie datum'},{key:'BijgewerktOp',label:'Laatst bijgewerkt op'},'Inspecteur']"
          bordered
          select-mode="single"
          selectable
          hover
          @row-selected="rowSelected"
        >
          <template 
            #cell(Omschrijving)="data" 
            align="center"
          >
            {{ data.item.p.Omschrijving || 'Geen omschrijving' }}
            <i 
              v-if="data.item.p.IsBevroren" 
              class="fa fa-lock"
            />
          </template>
          <template
            #cell(Unit)="data"
            align="center"
          >
            {{ data.item.unit.UnitKenmerk }}
          </template>
          <template
            #cell(Datum)="data"
            align="center"
          >
            {{ data.item.p.Datum | formatDateTime("DD-MM-YYYY") }}
          </template>

          <template
            #cell(BijgewerktOp)="data"
            align="center"
          >
            {{ data.item.p.BijgewerktOp | fromNow }}
          </template>

          <template 
            #cell(Inspecteur)="data" 
            align="center"
          >
            {{ data.item.p.Inspecteur }}
          </template>
        </b-table>
      </b-card-body>
    </b-card>
  </b-container>
</template>
<script>
import { serviceMixin } from "@/mixins/serviceMixin";

export default {
     mixins: [serviceMixin],
 

  data() {
    return {
      templates: [],
    };
  },
  computed: {
    templatelijst: function() {
      return this.templates.slice().reverse().map(t => { return { p: t.prognose, unit:t.unit } } )
    }
  },
  mounted() {
      this.getTemplates()
  },
  methods: {
    rowSelected(record) {
      console.log(record);
      this.openPrognose(record[0].p.Id,record[0].unit.Id);
    },
    openPrognose(prognoseId,unitId) {
      /*console.log("navigate to prognose");
      this.tabs.push({
        label: "Prognose",
        icon: "fa fa-table",
        to: {
          name: "Prognose",
          params: { prognoseid: prognoseId }
        }
      });*/
      // navigate to prognose
      this.$router.push({
        name: "Prognose",
        params: { prognoseid: prognoseId,id:unitId }
      });
    },

getTemplates() {
      console.log(" templates ophalen...");
      var vm = this;
      this.get("/inspectie/templates")
        .then(function (response) {
          vm.templates = response.data.inspecties;
          console.dir(response.data);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  }
    
}
</script>